import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {CONFIG} from "../app/config";

import {HttpClient} from "@angular/common/http";

@Injectable()
export class HttpService {

    constructor(public httpClient: HttpClient) {

    }

    get (url: string, options: any = {}, retry: boolean = false, timeout: number = CONFIG.request.totalTimeout): Observable<any> {
        let observable: Observable<any> = this.httpClient.get(url, options);
        return this.parseObservableRetry(observable, retry, timeout);
    }

    post(url: string, body: any, options: any = {}, retry: boolean = false, timeout: number = CONFIG.request.totalTimeout): Observable<any> {
        let observable: Observable<any> = this.httpClient.post(url, body, options).timeoutWith(timeout, Observable.throw(CONFIG.request.timeoutErroPadrao));
        return this.parseObservableRetry(observable, retry, timeout);
    }

    put(url: string, body: any, options: any = {}, retry: boolean = false, timeout: number = CONFIG.request.totalTimeout): Observable<any> {
        let observable: Observable<any> = this.httpClient.put(url, body, options);
        return this.parseObservableRetry(observable, retry, timeout);
    }

    delete(url: string, options: any = {}, retry: boolean = false, timeout: number = CONFIG.request.totalTimeout): Observable<any> {
        let observable: Observable<any> = this.httpClient.delete(url, options);
        return this.parseObservableRetry(observable, retry, timeout);
    }

    private parseObservableRetry(observable: Observable<any>, retry: boolean = false, timeout: number): Observable<any> {

        // let result = ;
        // result.Result + '<br>' + erro.status + '-' + erro.statusText + '-' + erro.url
        return observable
            .retry(0)
            .retryWhen((errors) => {
                return this.retryLogic(errors, retry);
            })
            .timeoutWith(timeout, Observable.throw(CONFIG.request.timeoutErroPadrao));

    }

    // so pode dar retry se for erro de conexão/timeout
    // não pode dar retry se for Result da bridge
    private retryLogic(errors: Observable<any>, retry: boolean = false): Observable<any> {

        return Observable.create(observer => {

            errors.subscribe(
                erro => {

                    if (erro.Bridge) {
                        observer.next();
                    }
                    else if (retry) {

                        if (erro.isBridgeResult) { // erro Result bridge (não é pau de servidor ou conexão/timeout)
                            observer.error(erro); // não fazendo retry
                        }
                        else { // conexão/timeout
                            setTimeout(() => {
                                observer.next(); // fazendo retry (next = positivo = fazer retry)
                            }, CONFIG.request.retryDelay);
                        }

                    }
                    else {
                        observer.error(erro); // não fazendo retry
                    }

                });

        });

    }

}



// WEBPACK FOOTER //
// ./src/providers/http-service.ts